import {Input, Radio} from '@mantine/core';
import {Flex} from 'src/design/atoms/Flex';
import {Space} from 'src/design/atoms/Space';
import {Text} from 'src/design/atoms/Text';
import React, {useCallback} from 'react';
import type {IFormFieldV2} from 'src/types/FormV2';

const scaleOptions = [
  {label: 1},
  {label: 2},
  {label: 3},
  {label: 4},
  {label: 5},
];

export interface FormScaleV2Props {
  field: IFormFieldV2;
  value?: string;
  error?: string;
  onChange: (name: string, value: string | number) => void;
}

export const FormScaleV2 = React.memo<FormScaleV2Props>(
  ({field, value, error, onChange}: FormScaleV2Props) => {
    const handleChange = useCallback(
      (value: string): void => {
        onChange(field.name, value);
      },
      [field.name, onChange]
    );

    return (
      <Input.Wrapper
        data-testid={`form-field-${field.name}`}
        label={field.label}
        description={field.description}
        error={error}
        withAsterisk={field.required}
        mb="sm">
        <Space mb="xs" />
        <Radio.Group value={value?.toString()} onChange={handleChange}>
          <Flex direction="row">
            {scaleOptions.map((option, index) => (
              <Flex
                direction="column"
                key={option.label}
                style={{flex: '1 1 0', minWidth: 0}}>
                <Radio
                  mx="auto"
                  value={option.label.toString()}
                  disabled={field.disabled}
                />
                <Text size="xs" mx="auto">
                  {option.label}
                </Text>
                {index === 0 && (
                  <Text size="xs" mx="auto">
                    {field.scaleOptions?.leastValueText || 'Least'}
                  </Text>
                )}
                {index === scaleOptions.length - 1 && (
                  <Text size="xs" mx="auto">
                    {field.scaleOptions?.mostValueText || 'Most'}
                  </Text>
                )}
              </Flex>
            ))}
          </Flex>
        </Radio.Group>
      </Input.Wrapper>
    );
  }
);
